export default __webpack_public_path__ + "static/media/regularizate.b63188f2.jpg";